export default __webpack_public_path__ + "static/media/5453@3x.70f29fbf.webp";